module.exports = __webpack_public_path__ + "static/img/digtal2.47a38be.png";


//////////////////
// WEBPACK FOOTER
// ./public/visualImg/digtal2.png
// module id = vMuf
// module chunks = 0